
/* scroll-reveal motion layer (progressive, reduced-motion safe) */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
  var sel='.hero .eyebrow,.hero h1,.hero .sub,.hero .b,.hero .cta,.sec .eyebrow,.sec h2,.lead,.narrow p,.col,.cmp .c,.graph,.tier,.pcard,.rcard,.pcell,.acc,.oth,.bundle,.fys,.two>*';
  document.querySelectorAll(sel).forEach(function(el){el.classList.add('reveal');io.observe(el);});
  document.querySelectorAll('.three,.cmp,.tiers,.picks,.rev3,.pair,.setup,.others').forEach(function(g){Array.prototype.forEach.call(g.children,function(c,i){c.style.transitionDelay=(i*70)+'ms';});});
  if(reduce){document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');});}
})();
